import { Link } from "react-router-dom";

const friendLinks = ["影视资料库", "追剧指南", "剧评社区", "幕后花絮站", "角色关系详解", "剧集时间线"];

export default function SiteIntro() {
  return (
    <section className="py-14">
      <div className="mx-auto grid w-full max-w-[1280px] gap-8 px-4 md:px-6 lg:grid-cols-[1.4fr_1fr]">
        <div>
          <h2 className="font-heading text-2xl font-semibold text-foreground-900">关于本站</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            “年轻的母亲”影视专题站，是一个专注于这部剧集的内容门户。我们希望把散落各处的剧情线索、角色关系与幕后故事，
            整理成一条清晰、好读、随时可查的内容线。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            你可以在这里浏览按季更新的剧情介绍，查阅主要演员与角色的详细资料，也可以直接观看精彩片段的回顾与花絮。
            无论你是刚入坑的新观众，还是已经追完全剧的老朋友，都能找到想看的内容。
          </p>
          <div className="mt-6 grid grid-cols-3 gap-4">
            {[
              { num: "2", label: "完整季数" },
              { num: "13", label: "剧情篇章" },
              { num: "13", label: "演员阵容" },
            ].map((item) => (
              <div key={item.label} className="rounded-lg bg-primary-50 px-4 py-3">
                <p className="font-heading text-2xl font-semibold text-primary-600">{item.num}</p>
                <p className="mt-1 text-xs text-foreground-500">{item.label}</p>
              </div>
            ))}
          </div>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-information-line"></i>了解更多
          </Link>
        </div>

        <div className="rounded-lg border border-background-200/70 bg-background-100 p-6">
          <h3 className="font-heading text-lg font-semibold text-foreground-900">友情链接</h3>
          <p className="mt-2 text-xs text-foreground-500">与你一起追剧的同好站点</p>
          <ul className="mt-4 flex flex-wrap gap-2">
            {friendLinks.map((link) => (
              <li key={link}>
                <span className="inline-block rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-600">
                  {link}
                </span>
              </li>
            ))}
          </ul>
          <div className="mt-6 rounded-lg bg-accent-50 p-4">
            <p className="text-sm font-medium text-accent-800">找不到想看的内容？</p>
            <p className="mt-1 text-xs text-foreground-500">
              试试顶部导航的搜索，输入剧名、演员或片段关键词即可快速定位。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}